import { createSlice } from "@reduxjs/toolkit";

// All-'none' permission = no access. Used as the default and on load failure.
export const NO_PERMISSION = {
  p_select: "none",
  p_read: "none",
  p_create: false,
  p_update: "none",
  p_delete: "none",
  p_publish: false,
};

const initialState = {
  loaded: false, // has the kirtan permission been fetched yet this session?
  kirtan: NO_PERMISSION, // caller's permission on the 'kirtan' module
  user: null, // { user_id, user_name, email, role_id }
};

export const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setKirtanPermission: (state, action) => {
      state.kirtan = { ...NO_PERMISSION, ...(action.payload || {}) };
      state.loaded = true;
    },
    setAuthUser: (state, action) => {
      state.user = action.payload;
    },
    clearPermission: (state) => {
      state.loaded = false;
      state.kirtan = NO_PERMISSION;
      state.user = null;
    },
  },
});

export const { setKirtanPermission, setAuthUser, clearPermission } = permissionSlice.actions;
export default permissionSlice.reducer;
